import { useEffect, useState } from 'react'
import { getHttp, postHttp } from 'src/api'
import { PATH_API } from 'src/helpers/path'
import { useAppContext } from 'src/helpers/app'
import { StyleImagePreferenceOption } from 'src/types'

export function useFlowerSelection() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [images, setImages] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const { sessionID, storeURLParameters } = useAppContext()

  const saveSelectedFlowers = async (selectedImageIds: number[]) => {
    try {
      const response = await postHttp(PATH_API.bulkRecord, {
        uniqueIdentifier: sessionID,
        selectedImageIds,
        urlParameters: storeURLParameters ?? undefined,
      })
      return response.data
    } catch (error) {
      console.error('Error saving selected flowers:', error)
      throw error
    }
  }

  useEffect(() => {
    const selectedPaletteId = localStorage.getItem('selectedPaletteId')
    if (!selectedPaletteId) {
      setError('No color palette selected.')
      setIsLoading(false)
      return
    }

    // Get images from localStorage by paletteId
    const cachedImages = localStorage.getItem(`flowerImagesForPalette_${selectedPaletteId}`)
    if (cachedImages) {
      try {
        const parsed = JSON.parse(cachedImages)
        setImages(parsed)
        setIsLoading(false)
        return // If there is cache, don't call the API again
      } catch (e) {
        // If there is an error parsing, continue to call the API
      }
    }

    // If there is no cache, call the API
    setIsLoading(true)
    getHttp(PATH_API.getQuizSessionData)
      .then((res) => {
        const allOptions: StyleImagePreferenceOption[] = res.data.imagePreferenceOptions || []
        const filtered = allOptions.filter(
          (img: StyleImagePreferenceOption) => img.colorPaletteId?.toString() == selectedPaletteId
        )
        setImages(filtered)
        localStorage.setItem(`flowerImagesForPalette_${selectedPaletteId}`, JSON.stringify(filtered))
      })
      .catch(() => {
        setError('Failed to load images.')
      })
      .finally(() => setIsLoading(false))
  }, [])

  return {
    images,
    isLoading,
    error,
    saveSelectedFlowers,
  }
}
